import { GoInbox } from "react-icons/go";

const EmptyData = () => {
  return (
    <div className="flex flex-col w-full items-center justify-center gap-y-6 h-full font-poppins bg-[radial-gradient(circle, white,light-green-50,white)]">
      <GoInbox className="h-[70px] w-[70px] text-dark-green" />
      <h2 className="text-2xl text-dark-green font-bold">
        Aún no hay datos registrados
      </h2>
    </div>
  );
};

export default EmptyData;
